// extracted by mini-css-extract-plugin
module.exports = {"copyInvite":"CopyInviteLink_copyInvite__1uhtG","copyInvite__url":"CopyInviteLink_copyInvite__url__1i7Tr"};